var _dec, _class, _Mask;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import { Component } from 'react';
import noScroll from 'no-scroll';
import { withStyle } from '@instructure/emotion';
import { ensureSingleChild, omitProps } from '@instructure/ui-react-utils';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { allowedProps, propTypes } from './props';
import MaskCounter from './MaskCounter';

/**
---
category: components/utilities
---
**/
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
let Mask = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_Mask = class Mask extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleElementRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
    // It can be a ref for any type of child
    this._content = void 0;
    this.contentRef = el => {
      this._content = el;
    };
  }
  componentDidMount() {
    var _this$props$makeStyle, _this$props;
    (_this$props$makeStyle = (_this$props = this.props).makeStyles) === null || _this$props$makeStyle === void 0 ? void 0 : _this$props$makeStyle.call(_this$props);
    if (this.props.fullscreen) {
      noScroll.on();
      MaskCounter.incrementCounter();
    }
  }
  componentDidUpdate() {
    var _this$props$makeStyle2, _this$props2;
    (_this$props$makeStyle2 = (_this$props2 = this.props).makeStyles) === null || _this$props$makeStyle2 === void 0 ? void 0 : _this$props$makeStyle2.call(_this$props2);
  }
  componentWillUnmount() {
    if (this.props.fullscreen) {
      MaskCounter.decrementCounter();
      if (MaskCounter.getCounter() <= 0) {
        noScroll.off();
      }
    }
  }
  render() {
    var _this$props$styles;
    const content = ensureSingleChild(this.props.children, {
      ref: this.contentRef
    });
    const props = {
      ...omitProps(this.props, Mask.allowedProps),
      css: (_this$props$styles = this.props.styles) === null || _this$props$styles === void 0 ? void 0 : _this$props$styles.mask,
      ref: this.handleElementRef
    };
    if (typeof this.props.onClick === 'function') {
      props.onClick = this.props.onClick;
      props.tabIndex = -1;
    }
    return _jsx("span", {
      ...props,
      children: content
    });
  }
}, _Mask.displayName = "Mask", _Mask.componentId = 'Mask', _Mask.allowedProps = allowedProps, _Mask.propTypes = propTypes, _Mask.defaultProps = {
  placement: 'center',
  fullscreen: false
}, _Mask)) || _class);
export default Mask;
export { Mask };